import { html } from '@resn/gozer-core';
import { autobind } from 'core-decorators';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import Svg from 'component/svg';

import './index.scss';
import gsap from 'gsap/all';
import { bindAll } from 'underscore';
import store from 'core/store';
import assetsMixin from 'utils/loading/assets-mixin';

const template = ({ props, options, context }) => html`
    <div class="sidePanel">
        <div
            class="sidePanel__underlay sidePanel__underlay${options.showUnderlay ? '--show' : ''}"
            data-ui="underlay"
        ></div>

        <div class="sidePanel__inner" data-ui="inner">
            <header class="sidePanel__header text-body2 ${props.headerClassName}">
                ${options.headerContent({ props, options, context })}
                <div class="sidePanel__close" @click=${context.handleClose}>
                    ${Svg('close', 'sidePanel__closeIcon')}
                </div>
            </header>

            <div class="sidePanel__content">${options.content({ props, options, context })}</div>
        </div>
    </div>
`;

const headerContent = ({ props, options, context }) => html`<h3 class="text-heading6"></h3>`;

// This is placeholder content, please update in your view
const content = ({ props, options, context }) => html`
    <div>
        <header class="sidePanel__top">
            <h2 class="text-heading3">Lorem ipsum</h2>
            <h3 class="text-copyTitle2">Amet ullamco eiusmod eu fugiat adipisicing Lorem id voluptate</h3>
        </header>

        <div class="sidePanel__bottom">
            <h4>Lorem ipsum title</h4>
            <h5>Amet ullamco eiusmod eu fugiat adipisicing Lorem id voluptate</h5>
            <p>Ut culpa dolore ullamco irure nostrud dolor proident sit.</p>
            <p>
                Laboris veniam officia non ullamco. Amet sunt commodo reprehenderit cillum sint aliquip anim aliquip. Ex
                tempor ut sint sunt aliquip reprehenderit commodo proident.
            </p>
            <h4>Lorem ipsum title</h4>
            <h5>Amet ullamco eiusmod eu fugiat adipisicing Lorem id voluptate</h5>
            <p>Ut culpa dolore ullamco irure nostrud dolor proident sit.</p>
            <p>
                Laboris veniam officia non ullamco. Amet sunt commodo reprehenderit cillum sint aliquip anim aliquip. Ex
                tempor ut sint sunt aliquip reprehenderit commodo proident.
            </p>
            <h4>Lorem ipsum title</h4>
            <h5>Amet ullamco eiusmod eu fugiat adipisicing Lorem id voluptate</h5>
            <p>Ut culpa dolore ullamco irure nostrud dolor proident sit.</p>
            <p>
                Laboris veniam officia non ullamco. Amet sunt commodo reprehenderit cillum sint aliquip anim aliquip. Ex
                tempor ut sint sunt aliquip reprehenderit commodo proident.
            </p>
            <h4>Lorem ipsum title</h4>
            <h5>Amet ullamco eiusmod eu fugiat adipisicing Lorem id voluptate</h5>
            <p>Ut culpa dolore ullamco irure nostrud dolor proident sit.</p>
            <p>
                Laboris veniam officia non ullamco. Amet sunt commodo reprehenderit cillum sint aliquip anim aliquip. Ex
                tempor ut sint sunt aliquip reprehenderit commodo proident.
            </p>
        </div>
    </div>
`;

export default {
    options: {
        template,
        onClose: () => {},

        // Add headerTitle if there is no custom header within 'content' template
        headerTitle: 'Header',
        headerContent,

        // Add your html in this 'content' template
        content,
    },

    props: {
        open: false,
        headerClassName: '',
    },

    onBeforeSetup() {
        bindAll(this, 'handleClose');
    },

    async onSetup() {},

    onOpen() {
        gsap.killTweensOf(this.ui.inner);
        gsap.to(this.ui.inner, { x: '0%', duration: 1, ease: 'expo.out' });

        gsap.killTweensOf(this.ui.underlay);
        gsap.to(this.ui.underlay, { opacity: 0.7, duration: 1, ease: 'expo.out' });

        store().state.scrollLock = true;
    },

    offOpen({ firstTrigger }) {
        if (firstTrigger) return;

        gsap.killTweensOf(this.ui.inner);
        gsap.to(this.ui.inner, { x: '101%', duration: 0.6, ease: 'power2.in' });

        gsap.killTweensOf(this.ui.underlay);
        gsap.to(this.ui.underlay, { opacity: 0, duration: 1, ease: 'power2.in' });

        store().state.scrollLock = false;
    },

    handleClose() {
        this.props.open = false;
    },
};
